import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { FaChevronLeft } from "react-icons/fa";
import Bentologo from "../../images/favicon.png";

const Index = ({ isOpen, toggleSidebar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userRole, setUserRole] = useState("admin");

    useEffect(() => {
        try {
            const roleId = localStorage.getItem("bentoAdminDetails");
            if (roleId === '5' || roleId === 'support') {
                setUserRole("support");
            } else {
                setUserRole("admin");
            }
        } catch(e) {
            console.error("Failed to get role from localStorage", e);
        }
    }, []);

    const handleNavigation = (path) => {
        navigate(path);
        if (window.innerWidth < 1024) {
            toggleSidebar(); // Auto-close on mobile after selection
        }
    }

    const menuGroups = [
        {
            title: "Orders & Fulfillment",
            items: [
                { name: "Pending Subscription Orders", path: "/PendingSubscriptionOrders" },
                { name: "Completed Subscription Orders", path: "/CompletedSubscriptiOnorders" },
                { name: "Pending Add-on Subscription Orders", path: "/AddonOrders" },
                { name: "Completed Add-on Orders", path: "/CompletedAddonOrders" },
                { name: "Pending One Time Orders", path: "/PendingOnetimeOrders" },
                { name: "Completed One Time Orders", path: "/CompletedOneTimeOrders" },
                { name: "Create One Time Order", path: "/onetimeorder/create" },
                { name: "Order Self Deliver", path: "/OrderSelfDeliver" },
                { name: "Bulk Orders", path: "/bulk-orders" },
                { name: "Bulk WhatsApp Messages", path: "/bulk-whatsapp-messages" },
                { name: "WhatsApp Bulk Message Logs", path: "/bulk-whatsapp-message-logs" },
                { name: "Batches", path: "/batches" },
                { name: "Get Orders", path: "/GetOrders" },
            ]
        },
        {
            title: "Subscriptions",
            items: [
                { name: "Active Subscriptions", path: "/ActiveSubscriptons" },
                { name: "Completed Subscriptions", path: "/CompletedSubscriptons" },
                { name: "Create Subscription", path: "/subscription/create" },
            ]
        },
        {
            title: "Network Management",
            items: [
                { name: "All Users", path: "/AllUsers" },
                { name: "All Chefs", path: "/AllChef" },
                { name: "All Riders", path: "/AllRiders" },
                { name: "Rider Dashboard", path: "/RiderDashboard" },
                { name: "All Restaurants", path: "/AllRestaurants" },
                { name: "Unauthorized Chefs", path: "/unAuthorizedChefs" },
                { name: "Unauthorized Riders", path: "/unAuthorizedRiders" },
            ]
        },
        {
            title: "Operations & Finance",
            items: [
                { name: "Transactions", path: "/transactions" },
                { name: "Delayed Orders", path: "/delayed-orders" },
                { name: "Refund Requests", path: "/refund-requests" },
                { name: "Order Ratings", path: "/ratings/orders" },
                { name: "Add BB Coins", path: "/AddBbCoins" },
                { name: "Add Coupon", path: "/addCoupon" },
                { name: "Edit Container", path: "/editContainer" },
                { name: "Week Meal Not Added", path: "/weekmealnotadded" },
                { name: "Custom Dashboard", path: "/Customdashboard" },
            ]
        }
    ];

    return (
        <div
            className={`flex flex-col bg-gray-900 text-white shadow-2xl transition-all duration-300 ease-in-out flex-shrink-0 absolute md:relative z-[100] h-full overflow-hidden ${isOpen ? 'w-72' : 'w-0'}`}
        >
            <div className="w-72 h-full flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center px-4 h-12 border-b border-gray-800 bg-gray-950 shrink-0">
                <div className="flex items-center gap-3 min-w-0 pr-2">
                    <img src={Bentologo} alt="Bento Box Logo" className="w-8 h-8 object-contain shrink-0" />
                    <h2 className="text-sm font-bold tracking-wide text-gray-100 truncate">
                        {userRole === "support" ? "BentoBox Support Portal" : "BentoBox Admin Portal"}
                    </h2>
                </div>
                <button onClick={toggleSidebar} className="p-1.5 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white transition-colors cursor-pointer group shrink-0">
                    <FaChevronLeft className="text-sm  transition-transform" />
                </button>
            </div>

            {/* Menu List */}
            <div className="flex-1 py-1 flex flex-col justify-start overflow-y-auto [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-gray-700 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent">
                <div className="px-2 pb-2 space-y-1.5">
                    {menuGroups.map((group, gIdx) => (
                        <div key={gIdx}>
                            <h3 className="px-3 text-[11px] font-extrabold uppercase tracking-widest text-gray-500 mb-1 mt-2 first:mt-0 relative z-10">
                                {group.title}
                            </h3>
                            <ul className="flex flex-col relative ml-[15px] border-l border-gray-700/50">
                                {group.items.map((item, idx) => {
                                    const isActive = location.pathname.toLowerCase() === item.path.toLowerCase();
                                    // Is last item? We might want to remove the tail of the border, but a full border is fine.
                                    return (
                                        <li key={idx} className="relative pl-3 before:absolute before:content-[''] before:w-3 before:h-px before:bg-gray-700/50 before:left-0 before:top-1/2 before:-translate-y-1/2">
                                            <button
                                                onClick={() => handleNavigation(item.path)}
                                                className={`w-full text-left flex items-center px-3 py-1 text-[13px] font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap ${isActive
                                                        ? 'bg-orange-500/10 text-orange-400'
                                                        : 'text-gray-400 hover:bg-gray-800/60 hover:text-gray-200 hover:translate-x-1'
                                                    }`}
                                            >
                                                <span>{item.name}</span>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </div>
    )
}

export default Index
